export default "/corgi/pageapps/purchase/_next/static/media/google.8005dbbe.svg";